<template>
  <div class="grow" ref="slideContainer">
    <Title :zhTitle="pageData.name" :enTitle="pageData.name"></Title>
    <div class="cards" v-if="pageData">
      <div class="card" v-if="yysr">
        <div v-if="language === 'zh'" class="zh">
          <div class="card-title">{{ jsonData.year }}{{ periodName }} <span class="card-text">营业收入</span></div>
          <div class="num">
            {{ yysr }}<span class="unit">{{ yysrUnit }}</span>
          </div>
        </div>
        <div v-else-if="language === 'en'" class="en">
          <div class="num">
            {{ yysr }}<span class="unit">{{ yysrUnit }}</span>
          </div>
          <div class="card-title">{{ jsonData.year }}{{ periodNameEng }}</div>
          <div class="card-text">Sales from Operations</div>
        </div>
        <div class="charts" ref="chart1"></div>
      </div>
      <div class="card" v-if="gmjlr">
        <div v-if="language === 'zh'" class="zh">
          <div class="card-title">{{ jsonData.year }}{{ periodName }} <span class="card-text">归母净利润</span></div>
          <div class="num">
            {{ gmjlr }}<span class="unit">{{ gmjlrUnit }}</span>
          </div>
        </div>
        <div v-else-if="language === 'en'" class="en">
          <div class="num">
            {{ gmjlr }}<span class="unit">{{ gmjlrUnit }}</span>
          </div>
          <div class="card-title">{{ jsonData.year }}{{ periodNameEng }}</div>
          <div class="card-text">Net Income Attributed to Shareholders</div>
        </div>
        <div class="charts" ref="chart2"></div>
      </div>
      <div class="card" v-if="kfgmjlr">
        <div v-if="language === 'zh'" class="zh">
          <div class="card-title">{{ jsonData.year }}{{ periodName }} <span class="card-text">扣非归母净利润</span>
          </div>
          <div class="num">
            {{ kfgmjlr }}<span class="unit">{{ kfgmjlrUnit }}</span>
          </div>
        </div>
        <div v-else-if="language === 'en'" class="en">
          <div class="num">
            {{ kfgmjlr }}<span class="unit">{{ kfgmjlrUnit }}</span>
          </div>
          <div class="card-title">{{ jsonData.year }}{{ periodNameEng }}</div>
          <div class="card-text">Net Income Attributed to Shareholders of the Company before Non-recurring Gains and
            Losses
          </div>
        </div>
        <div class="charts" ref="chart3"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Title from '@/components/title.vue'
import * as echarts from 'echarts'
import {mapState} from 'vuex'

export default {
  name: 'grow',
  components: {
    Title,
  },
  props: {
    index: {
      type: Number,
    },
  },
  data() {
    return {
      type: '', //bar,area,3d，显示类型
      barOption: {
        //echarts图配置
        tooltip: {
          show: false,
        },
        legend: {
          show: false,
        },
        color: ['#d32f2e'],
        xAxis: {
          data: [],
          type: 'category',
          //刻度线
          axisLine: {
            lineStyle: {
              color: '#EFD0CC',
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            color: '#696969',
            fontSize: 12,
            interval: 0, // 显示所有类目
            showMinLabel: true, // 显示最小类目标签
            showMaxLabel: true, // 显示最大类目标签
            padding: [5, 10], // 增加内边距
          },
          // 鼠标悬浮阴影
          axisPointer: {
            type: 'shadow',
          },
        },
        yAxis: {
          show: false,
          axisLabel: {
            show: false, // 不显示轴标签
          },
        },
        grid: {
          left: '8%',
          right: '8%',
          bottom: 10,
          containLabel: true,
        },
        series: [
          // 第一个圆柱顶部的椭圆形
          {
            type: 'pictorialBar', //pictorialBar(象形柱图)
            symbolSize: [18, 6], //椭圆的大小[宽，高]
            symbolOffset: [0, -3], //图形偏移[x轴，y轴]，不确定的话，可以微调，本实例x轴叠加了柱状之间的间距[-7+(间距7/2),y轴]
            z: 12, //图形的层级，控制图形的前后顺序，z值小的图形会被z值大的图形覆盖
            symbolPosition: 'end', //椭圆位置，默认'start'，在最底下，end是最上面
            itemStyle: {
              color: '#F06160',
            },
            data: [],
          },
          {
            data: [],
            type: 'bar',
            barWidth: 18,
            label: {
              show: true,
              position: 'top',
            },
            itemStyle: {
              // 图形样式
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0, // 0%处的颜色
                  color: '#d32f2e',
                },
                {
                  offset: 1, // 100%处的颜色
                  color: '#FEAB66',
                },
              ]),
            },
          },
          // 第一个圆柱底部的椭圆形
          {
            type: 'pictorialBar',
            symbolSize: [18, 6],
            symbolOffset: [0, 1],
            z: 12,
            itemStyle: {
              color: '#F06160',
            },
            data: [],
          },
        ],
      },
      observer: null, // IntersectionObserver 对象
      bar1Data: {
        xAxisData: [],
        seriesData: [],
      },
      bar2Data: {
        xAxisData: [],
        seriesData: [],
      },
      bar3Data: {
        xAxisData: [],
        seriesData: [],
      },
      pageData: {},
      yysr: '', // 销售收入
      yysrUnit: '', // 销售收入单位
      gmjlr: '', // 净利润
      gmjlrUnit: '', // 净利润单位
      kfgmjlr: '', // 扣非净利润
      kfgmjlrUnit: '', // 扣非净利润单位
    }
  },
  computed: {
    ...mapState(['theme', 'language', 'jsonData', 'periodName', 'periodNameEng', 'isLongChart']),
  },
  watch: {
    language(newData, oldData) { // 语言切换
      this.initData(); // 语言切换重新初始化数据
    }
  },
  mounted() {
    this.initData(); // 初始化数据
  },
  beforeDestroy() { // 组件销毁时销毁echarts实例
    const myChart1 = echarts.init(this.$refs.chart1)
    const myChart2 = echarts.init(this.$refs.chart2)
    const myChart3 = echarts.init(this.$refs.chart3)
    if (this.observer) {
      this.observer.disconnect()
    }
    if (myChart1) {
      myChart1.dispose()
    }
    if (myChart2) {
      myChart2.dispose()
    }
    if (myChart3) {
      myChart3.dispose()
    }
  },
  methods: {
    initData() { // 初始化数据
      this.initObserver() // 初始化IntersectionObserver
      let data = JSON.parse(this.jsonData.moduleData)
      if (this.language == 'zh') { // 根据语言获取相应数据
        data = JSON.parse(this.jsonData.moduleData)
      } else {
        data = JSON.parse(this.jsonData.moduleDataEng)
      }
      this.pageData = data[this.index] // 获取当前页面数据
      this.type = data[this.index].graphId == 5 ? '3d' : data[this.index].graphId == 1 ? 'bar' : 'area' // 获取图形类型
      if (this.pageData.yysrData.length > 0) { // 销售收入数据
        if (this.pageData.yysrData[this.pageData.yysrData.length - 1].period.match(/\d+/) != this.jsonData.year || this.pageData.yysrData[this.pageData.yysrData.length - 1].value === '') { // 判断是否为最新年份数据
          this.yysr = this.language === 'zh' ? '未披露' : 'Undisclosed';
        } else {
          this.yysr = this.pageData.yysrData[this.pageData.yysrData.length - 1].value
          this.yysrUnit = this.pageData.yysrData[this.pageData.yysrData.length - 1].unit
        }
        this.bar1Data.xAxisData = []; // x轴数据
        this.bar1Data.seriesData = []; // y轴数据
        this.pageData.yysrData.forEach(item => {
          if (item.realityValue !== '') { // 真是值有值的话设置x轴和y轴数据
            this.bar1Data.xAxisData.push(item.period)
            this.bar1Data.seriesData.push({
              value: item.realityValue.replace(/,/g, ''),
              label: item.value,
              unit: item.unit
            })
          }
        })
      }
      if (this.pageData.gmjlrData.length > 0) { // 净利润数据
        if (this.pageData.gmjlrData[this.pageData.gmjlrData.length - 1].period.match(/\d+/) != this.jsonData.year || this.pageData.gmjlrData[this.pageData.gmjlrData.length - 1].value === '') { // 判断是否为最新年份数据 并且是否有数据
          this.gmjlr = this.language === 'zh' ? '未披露' : 'Undisclosed';
        } else { // 有数据设置数据
          this.gmjlr = this.pageData.gmjlrData[this.pageData.gmjlrData.length - 1].value
          this.gmjlrUnit = this.pageData.gmjlrData[this.pageData.gmjlrData.length - 1].unit
        }
        this.bar2Data.xAxisData = []; // x轴数据
        this.bar2Data.seriesData = []; // y轴数据
        this.pageData.gmjlrData.forEach(item => {
          if (item.realityValue !== '') { // 真是值有值的话设置x
            this.bar2Data.xAxisData.push(item.period)
            this.bar2Data.seriesData.push({
              value: item.realityValue.replace(/,/g, ''),
              label: item.value,
              unit: item.unit
            })
          }
        })
      }
      if (this.pageData.kfgmjlrData.length > 0) { // 扣非净利润数据
        if (this.pageData.kfgmjlrData[this.pageData.kfgmjlrData.length - 1].period.match(/\d+/) != this.jsonData.year || this.pageData.kfgmjlrData[this.pageData.kfgmjlrData.length - 1].value === '') { // 判断是否为最新年份数据 并且是否有数据
          this.kfgmjlr = this.language === 'zh' ? '未披露' : 'Undisclosed';
        } else { // 有数据设置数据
          this.kfgmjlr = this.pageData.kfgmjlrData[this.pageData.kfgmjlrData.length - 1].value
          this.kfgmjlrUnit = this.pageData.kfgmjlrData[this.pageData.kfgmjlrData.length - 1].unit
        }
        this.bar3Data.xAxisData = []; // x轴数据
        this.bar3Data.seriesData = []; // y轴数据

        this.pageData.kfgmjlrData.forEach(item => {
          if (item.realityValue !== '') { // 真是值有值的话设置x轴和y轴数据
            this.bar3Data.xAxisData.push(item.period)
            this.bar3Data.seriesData.push({
              value: item.realityValue.replace(/,/g, ''),
              label: item.value,
              unit: item.unit
            })
          }
        })
      }
    },
    initObserver() {
      if (this.isLongChart) { // 如果是长图就直接初始化图表
        setTimeout(() => {
          this.initChart();
        }, 200)
      } else { // 如果不是长图就创建一个IntersectionObserver
        // 创建一个新的 IntersectionObserver 对象，当其监听到目标元素的可见部分（的比例）超过了一个或多个阈值（threshold）时，会执行指定的回调函数
        this.observer = new IntersectionObserver(
            entries => {
              entries.forEach(entry => {
                if (entry.isIntersecting) {
                  this.initChart() // 初始化图表
                  this.observer.disconnect() // 一旦元素进入视窗，就断开观察器
                }
              })
            },
            {
              threshold: 0.1, // 当目标元素的可见比例达到0%时，触发回调
            }
        )
        this.observer.observe(this.$refs.slideContainer)
      }
    },
    initChart() {
      // 初始化图表
      if (this.$refs.chart1) {
        const myChart1 = echarts.init(this.$refs.chart1)
        const option1 = JSON.parse(JSON.stringify(this.barOption))
        option1.xAxis.data = this.bar1Data.xAxisData // 设置x轴数据
        option1.series[1].label.formatter = params => { // 设置y轴数据
          if (this.language == 'zh') { // 根据语言获取相应数据
            return params.data.label + params.data.unit
          } else {
            return params.data.label + params.data.unit.substring(0, 1)
          }
        }

        if (this.type == '3d') { // 3d图形
          let topArr = []
          topArr = this.bar1Data.seriesData.map(item => { // 设置顶部数据
            if (item.label < 0) {
              return {
                value: item.value,
                symbolOffset: [0, 3],
              }
            } else {
              return {
                value: item.value,
              }
            }
          })
          let bottomArr = []
          bottomArr = this.bar1Data.seriesData.map(item => { // 设置底部数据
            if (item.value < 0) {
              return {
                value: item.value,
                symbolOffset: [0, -1],
              }
            } else {
              return {
                value: item.value,
              }
            }
          })
          option1.series[0].data = topArr // 设置顶部数据
          option1.series[1].data = this.bar1Data.seriesData
          option1.series[2].data = bottomArr // 设置底部数据
          option1.series[1].itemStyle.color = params => { // 设置颜色
            if (params.data.value < 0) { // 颜色渐变
              return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 1, // 0%处的颜色
                  color: '#d32f2e',
                },
                {
                  offset: 0, // 100%处的颜色
                  color: '#FEAB66',
                },
              ])
            } else {
              return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0, // 0%处的颜色
                  color: '#d32f2e',
                },
                {
                  offset: 1, // 100%处的颜色
                  color: '#FEAB66',
                },
              ])
            }
          }
        } else if (this.type == 'bar') { // 柱状图
          option1.series[0].data = []
          option1.series[1].data = this.bar1Data.seriesData // 设置数据
          option1.series[1].itemStyle.borderRadius = 8 // 设置圆角
          option1.series[2].data = []
        } else if (this.type == 'area') { // 折线图
          option1.series[0].data = []
          option1.series[1].data = this.bar1Data.seriesData // 设置数据
          option1.series[1].type = 'line' // 折线
          option1.series[1].smooth = true // 平滑
          option1.series[1].symbol = 'circle' // 圆点
          option1.series[1].symbolSize = 6 // 圆点大小
          option1.series[1].areaStyle = { // 填充颜色
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 1,
                color: 'rgba(254,171,102,0)',
              },
              {
                offset: 0,
                color: 'rgba(235,92,91,0.7)',
              },
            ]),
          }
          option1.series[2].data = []
        }
        if (this.theme == 'red') { // 红色
          option1.series[1].itemStyle.color = params => { // 设置颜色
            if (params.data.value < 0) { // 颜色渐变
              return new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                {
                  offset: 0, // 0%处的颜色
                  color: '#d32f2e',
                },
                {
                  offset: 1, // 100%处的颜色
                  color: '#FEAB66',
                },
              ])
            } else {
              return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0, // 0%处的颜色
                  color: '#d32f2e',
                },
                {
                  offset: 1, // 100%处的颜色
                  color: '#FEAB66',
                },
              ])
            }
          }
        } else if (this.theme == 'purple') { // 紫色
          option1.series[0].itemStyle.color = '#FFF1D0'
          option1.series[1].itemStyle.color = '#F9CD70'
          if (option1.series[1].areaStyle) { // 如果折线图存在设置折线图区域颜色
            option1.series[1].areaStyle = {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 1,
                  color: 'rgba(249, 205, 112, 0)',
                },
                {
                  offset: 0,
                  color: 'rgba(249, 205, 112, 0.70)',
                },
              ]),
            }
          }
          option1.series[1].label.color = '#2A234C' // 设置颜色
          option1.series[1].label.fontSize = 12 // 设置字体大小
          option1.series[1].label.fontWeight = 400 // 设置字体粗细
          option1.series[2].itemStyle.color = '#EBB94F' // 设置颜色
        } else if (this.theme == 'blue') { // 蓝色
          option1.color = ['#4782EA'] // 设置颜色
          option1.xAxis.axisLine.lineStyle.color = '#E5E5E5'
          option1.series[0].itemStyle.color = '#92D5FF'
          option1.series[1].itemStyle.color = params => {
            if (params.data.value < 0) { // 颜色渐变
              return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 1, // 0%处的颜色
                  color: '#59B9F5',
                },
                {
                  offset: 0, // 100%处的颜色
                  color: '#D7F0FF',
                },
              ])
            } else {
              return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0, // 0%处的颜色
                  color: '#59B9F5',
                },
                {
                  offset: 1, // 100%处的颜色
                  color: '#D7F0FF',
                },
              ])
            }
          }
          if (option1.series[1].areaStyle) { // 如果折线图存在设置折线图区域颜色
            option1.series[1].areaStyle = {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 1,
                  color: 'rgba(91, 186, 245, 0)',
                },
                {
                  offset: 0,
                  color: 'rgba(103, 191, 245, 1)',
                },
              ]),
            }
          }
          option1.series[1].label.color = '#000000'
          option1.series[1].label.fontSize = 12 // 设置字体大小
          option1.series[1].label.fontWeight = 400 // 设置字体粗细
          option1.series[2].itemStyle.color = '#C0E6FF'
        } else if (this.theme == 'yellow') { // 黄色
          option1.series[0].itemStyle.color = '#FFBE1E'
          option1.series[1].itemStyle.color = '#EDA900'
          option1.series[1].label.color = '#000000'
          option1.series[1].label.fontSize = 12 // 设置字体大小
          option1.series[1].label.fontWeight = 400 // 设置字体粗细
          option1.series[2].itemStyle.color = '#DFA20A' // 设置颜色

          if (option1.series[1].areaStyle) { // 如果折线图存在设置折线图区域颜色
            option1.series[1].areaStyle = {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 1,
                  color: 'rgba(248,188,39,0)',
                },
                {
                  offset: 0,
                  color: 'rgba(248,188,39,0.7)',
                },
              ]),
            }
          }
        }

        // 设置图表选项
        myChart1.setOption(option1) // 设置图表
      }
      if (this.$refs.chart2) {
        const myChart2 = echarts.init(this.$refs.chart2)
        const option2 = JSON.parse(JSON.stringify(this.barOption))

        option2.xAxis.data = this.bar2Data.xAxisData
        option2.series[1].label.formatter = params => {
          if (this.language == 'zh') {
            return params.data.label + params.data.unit
          } else {
            return params.data.label + params.data.unit.substring(0, 1)
          }
        }

        if (this.type == '3d') {
          let topArr = []
          topArr = this.bar2Data.seriesData.map(item => {
            if (item.value < 0) {
              return {
                value: item.value,
                symbolOffset: [0, 3],
              }
            } else {
              return {
                value: item.value,
              }
            }
          })
          let bottomArr = []
          bottomArr = this.bar2Data.seriesData.map(item => {
            if (item.value < 0) {
              return {
                value: item.value,
                symbolOffset: [0, -1],
              }
            } else {
              return {
                value: item.value,
              }
            }
          })
          option2.series[0].data = topArr
          option2.series[1].data = this.bar2Data.seriesData
          option2.series[2].data = bottomArr
          option2.series[1].itemStyle.color = params => {
            if (params.data.value < 0) {
              return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 1, // 0%处的颜色
                  color: '#d32f2e',
                },
                {
                  offset: 0, // 100%处的颜色
                  color: '#FEAB66',
                },
              ])
            } else {
              return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0, // 0%处的颜色
                  color: '#d32f2e',
                },
                {
                  offset: 1, // 100%处的颜色
                  color: '#FEAB66',
                },
              ])
            }
          }
        } else if (this.type == 'bar') {
          option2.series[0].data = []
          option2.series[1].data = this.bar2Data.seriesData
          option2.series[1].itemStyle.borderRadius = 8
          option2.series[2].data = []
        } else if (this.type == 'area') {
          option2.series[0].data = []
          option2.series[1].data = this.bar2Data.seriesData
          option2.series[1].type = 'line'
          option2.series[1].smooth = true
          option2.series[1].symbol = 'circle'
          option2.series[1].symbolSize = 6
          option2.series[1].areaStyle = {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 1,
                color: 'rgba(254,171,102,0)',
              },
              {
                offset: 0,
                color: 'rgba(235,92,91,0.7)',
              },
            ]),
          }
          option2.series[2].data = []
        }
        if (this.theme == 'red') {
          option2.series[1].itemStyle.color = params => {
            if (params.data.value < 0) {
              return new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                {
                  offset: 0, // 0%处的颜色
                  color: '#d32f2e',
                },
                {
                  offset: 1, // 100%处的颜色
                  color: '#FEAB66',
                },
              ])
            } else {
              return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0, // 0%处的颜色
                  color: '#d32f2e',
                },
                {
                  offset: 1, // 100%处的颜色
                  color: '#FEAB66',
                },
              ])
            }
          }
        } else if (this.theme == 'purple') {
          option2.series[0].itemStyle.color = '#D9EFFF'
          option2.series[1].itemStyle.color = '#8BCAEA'
          if (option2.series[1].areaStyle) {
            option2.series[1].areaStyle = {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 1,
                  color: 'rgba(139, 202, 234, 0)',
                },
                {
                  offset: 0,
                  color: 'rgba(139, 202, 234, 0.70)',
                },
              ]),
            }
          }
          option2.series[1].label.color = '#2A234C'
          option2.series[1].label.fontSize = 12
          option2.series[1].label.fontWeight = 400
          option2.series[2].itemStyle.color = '#72BDE4'
        } else if (this.theme == 'blue') {
          option2.color = ['#4782EA']
          option2.xAxis.axisLine.lineStyle.color = '#E5E5E5'
          option2.series[0].itemStyle.color = '#92D5FF'
          option2.series[1].itemStyle.color = params => {
            if (params.data.value < 0) {
              return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 1, // 0%处的颜色
                  color: '#59B9F5',
                },
                {
                  offset: 0, // 100%处的颜色
                  color: '#D7F0FF',
                },
              ])
            } else {
              return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0, // 0%处的颜色
                  color: '#59B9F5',
                },
                {
                  offset: 1, // 100%处的颜色
                  color: '#D7F0FF',
                },
              ])
            }
          }
          if (option2.series[1].areaStyle) {
            option2.series[1].areaStyle = {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 1,
                  color: 'rgba(91, 186, 245, 0)',
                },
                {
                  offset: 0,
                  color: 'rgba(103, 191, 245, 1)',
                },
              ]),
            }
          }
          option2.series[1].label.color = '#000000'
          option2.series[1].label.fontSize = 12
          option2.series[1].label.fontWeight = 400
          option2.series[2].itemStyle.color = '#C0E6FF'
        } else if (this.theme == 'yellow') {
          option2.series[0].itemStyle.color = '#FFBE1E'
          option2.series[1].itemStyle.color = '#EDA900'
          option2.series[1].label.color = '#000000'
          option2.series[1].label.fontSize = 12
          option2.series[1].label.fontWeight = 400
          option2.series[2].itemStyle.color = '#DFA20A'

          if (option2.series[1].areaStyle) {
            option2.series[1].areaStyle = {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 1,
                  color: 'rgba(248,188,39,0)',
                },
                {
                  offset: 0,
                  color: 'rgba(248,188,39,0.7)',
                },
              ]),
            }
          }
        }
        // 设置图表选项
        myChart2.setOption(option2)
      }
      if (this.$refs.chart3) {
        const myChart3 = echarts.init(this.$refs.chart3)
        const option3 = JSON.parse(JSON.stringify(this.barOption))

        option3.xAxis.data = this.bar3Data.xAxisData

        option3.series[1].label.formatter = params => {
          if (this.language == 'zh') {
            return params.data.label + params.data.unit
          } else {
            return params.data.label + params.data.unit.substring(0, 1)
          }
        }

        if (this.type == '3d') {
          let topArr = []
          topArr = this.bar3Data.seriesData.map(item => {
            if (item.value < 0) {
              return {
                value: item.value,
                symbolOffset: [0, 3],
              }
            } else {
              return {
                value: item.value,
              }
            }
          })
          let bottomArr = []
          bottomArr = this.bar3Data.seriesData.map(item => {
            if (item.value < 0) {
              return {
                value: item.value,
                symbolOffset: [0, -1],
              }
            } else {
              return {
                value: item.value,
              }
            }
          })
          option3.series[0].data = topArr
          option3.series[1].data = this.bar3Data.seriesData
          option3.series[2].data = bottomArr
          option3.series[1].itemStyle.color = params => {
            if (params.data.value < 0) {
              return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 1, // 0%处的颜色
                  color: '#d32f2e',
                },
                {
                  offset: 0, // 100%处的颜色
                  color: '#FEAB66',
                },
              ])
            } else {
              return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0, // 0%处的颜色
                  color: '#d32f2e',
                },
                {
                  offset: 1, // 100%处的颜色
                  color: '#FEAB66',
                },
              ])
            }
          }
        } else if (this.type == 'bar') {
          option3.series[0].data = []
          option3.series[1].data = this.bar3Data.seriesData
          option3.series[1].itemStyle.borderRadius = 8
          option3.series[2].data = []
        } else if (this.type == 'area') {
          option3.series[0].data = []
          option3.series[1].data = this.bar3Data.seriesData
          option3.series[1].type = 'line'
          option3.series[1].smooth = true
          option3.series[1].symbol = 'circle'
          option3.series[1].symbolSize = 6
          option3.series[1].areaStyle = {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 1,
                color: 'rgba(254,171,102,0)',
              },
              {
                offset: 0,
                color: 'rgba(235,92,91,0.7)',
              },
            ]),
          }
          option3.series[2].data = []
        }
        if (this.theme == 'red') {
          option3.series[1].itemStyle.color = params => {
            if (params.data.value < 0) {
              return new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                {
                  offset: 0, // 0%处的颜色
                  color: '#d32f2e',
                },
                {
                  offset: 1, // 100%处的颜色
                  color: '#FEAB66',
                },
              ])
            } else {
              return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0, // 0%处的颜色
                  color: '#d32f2e',
                },
                {
                  offset: 1, // 100%处的颜色
                  color: '#FEAB66',
                },
              ])
            }
          }
        } else if (this.theme == 'purple') {
          option3.series[0].itemStyle.color = '#FFE2EA'
          option3.series[1].itemStyle.color = '#F3ADBF'

          if (option3.series[1].areaStyle) {
            option3.series[1].areaStyle = {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 1,
                  color: 'rgba(243, 173, 191, 0)',
                },
                {
                  offset: 0,
                  color: 'rgba(243, 173, 191, 0.70)',
                },
              ]),
            }
          }
          option3.series[1].label.color = '#2A234C'
          option3.series[1].label.fontSize = 12
          option3.series[1].label.fontWeight = 400
          option3.series[2].itemStyle.color = '#E887A0'
        } else if (this.theme == 'blue') {
          option3.color = ['#4782EA']
          option3.xAxis.axisLine.lineStyle.color = '#E5E5E5'
          option3.series[0].itemStyle.color = '#92D5FF'
          option3.series[1].itemStyle.color = params => {
            if (params.data.value < 0) {
              return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 1, // 0%处的颜色
                  color: '#59B9F5',
                },
                {
                  offset: 0, // 100%处的颜色
                  color: '#D7F0FF',
                },
              ])
            } else {
              return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0, // 0%处的颜色
                  color: '#59B9F5',
                },
                {
                  offset: 1, // 100%处的颜色
                  color: '#D7F0FF',
                },
              ])
            }
          }
          if (option3.series[1].areaStyle) {
            option3.series[1].areaStyle = {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 1,
                  color: 'rgba(91, 186, 245, 0)',
                },
                {
                  offset: 0,
                  color: 'rgba(103, 191, 245, 1)',
                },
              ]),
            }
          }
          option3.series[1].label.color = '#000000'
          option3.series[1].label.fontSize = 12
          option3.series[1].label.fontWeight = 400
          option3.series[2].itemStyle.color = '#C0E6FF'
        } else if (this.theme == 'yellow') {
          option3.series[0].itemStyle.color = '#FFBE1E'
          option3.series[1].itemStyle.color = '#EDA900'
          option3.series[1].label.color = '#000000'
          option3.series[1].label.fontSize = 12
          option3.series[1].label.fontWeight = 400
          option3.series[2].itemStyle.color = '#DFA20A'

          if (option3.series[1].areaStyle) {
            option3.series[1].areaStyle = {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 1,
                  color: 'rgba(248,188,39,0)',
                },
                {
                  offset: 0,
                  color: 'rgba(248,188,39,0.7)',
                },
              ]),
            }
          }
        }
        // 设置图表选项
        myChart3.setOption(option3)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.red {
  .grow {
    margin-top: 14px;
    width: 1040px;
    height: 503px;
    position: relative;
    background: #ffffff;
    box-shadow: 2px 2px 10px 6px rgba(211, 47, 46, 0.07);
    border: 1px solid rgba(211, 47, 46, 0.07);
  }
}

.purple {
  .grow {
    margin-top: 14px;
    width: 1040px;
    height: 503px;
    position: relative;
    background: #ffffff;
    box-shadow: 2px 2px 10px 6px rgba(124, 98, 160, 0.06);
  }
}

.cards {
  margin-top: 12px;
  padding: 0 30px;
  display: flex;
  justify-content: space-around;
}

.card {
  width: 300px;
  height: 375px;
  border-radius: 8px;
  border: 1px solid var(--borderColor);
}

.card:nth-child(2) {
  margin-left: 40px;
}

.card:nth-child(3) {
  margin-left: 40px;
}

.zh .card-title {
  margin-top: 15px;
  margin-left: 16px;
  height: 28px;
  font-size: 16px;
  font-weight: 600;
  color: #0a0a0a;
  line-height: 22px;
}

.zh .card-text {
  color: var(--contentTitleColor);
  font-size: 20px;
}

.zh .num {
  margin-left: 16px;
  height: 45px;
  font-size: 32px;
  font-weight: 600;
  color: var(--numColor);
  line-height: 45px;
}

.unit {
  font-size: 16px;
}

.en {
  margin-top: 16px;
  margin-left: 15px;
}

.en .num {
  height: 45px;
  font-size: 32px;
  font-weight: 600;
  color: var(--numColor);
  line-height: 45px;
}

.en .card-title {
  height: 20px;
  font-size: 14px;
  font-weight: 600;
  color: #2a234c;
  line-height: 20px;
}

.en .card-text {
  height: 20px;
  font-size: 14px;
  font-weight: 600;
  color: var(--contentTitleColor);
  line-height: 20px;
}

.charts {
  width: 300px;
  height: 250px;
}

.blue {
  .grow {
    padding: 0 80px;
    padding-top: 27px;
    width: 980px;
    height: 489px;
    position: relative;
  }

  .cards {
    margin-top: 34px;
    padding: 0;
    display: flex;
    justify-content: center;
  }

  .card {
    width: 300px;
    height: 375px;
    background: #ecf2fd;
    border-radius: 8px;
    border: none;
  }
}

.yellow {
  .grow {
    width: 980px;
    height: 510px;
    padding: 0 80px;
    background: #f5f6f8;
    border-radius: 28px;
    position: relative;
  }

  .cards {
    margin-top: 34px;
    padding: 0;
    display: flex;
    justify-content: center;
  }

  .card {
    width: 300px;
    height: 375px;
    background: #ffffff;
    box-shadow: 6px 2px 9px 0px rgba(165, 165, 165, 0.2);
    border-radius: 8px;
    border: none;
  }
}
</style>
